<template>
    <el-dialog title="" :visible.sync="cashFlag" width="450px" :close-on-click-modal="false" :before-close="cancel">
        <div class="cash pt24">
          <div><img src="../../assets/images/new/withdrawal-success.png" alt=""></div>
          <div class="mt30 fb fontSize20">
            您成功提现<span class="titles moneys">{{money}}元</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cancel">返回</el-button>
        </span>
    </el-dialog>

</template>

<script>

export default {
    data () {
      return {
        cashFlag: false,
        money: "",
      }
    },
    created () {
      this.init();
    },
    methods: {
      init () {
        this.$on("set", function(org) {
          Object.assign(this.$data, this.$options.data());
          this.cashFlag = true;
          this.money = org;
        })
      },
      cancel () {
        this.cashFlag = false;
        this.$emit("handleChange", true)
      }
    }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
    height: auto !important;
    padding: 0 25px 30px;
}
/deep/ .el-dialog__footer {
  padding: 0 0 40px;
  text-align: center;
}
.cash {
    color: #111;
    text-align: center;
}

.dialogTitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
  .close {
    width: 14px;
    height: 14px;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}
</style>